import React from 'react';
import { Box, Checkbox, FormControlLabel } from '@mui/material';

import { DistanceField } from '@paragon/material';

import { getDefaultPiggybackSettings } from '../../../../library/profiles/profileTrussDefaults';
import { updateActivePiggybackSettings } from '../../../../store/actions/profileActions';
import {
  getComponentDesignBeingInserted,
  getComponentDesignInsertionInfoOrNull,
} from '../../../../store/selectors/insertionObjectSelectors';
import { useAppDispatch, useAppSelector } from '../../../hooks';

export const InsertionProfilePiggybackSettings = () => {
  const dispatch = useAppDispatch();

  const insertionInfo = useAppSelector(getComponentDesignInsertionInfoOrNull);
  const profile = useAppSelector(getComponentDesignBeingInserted)?.profile ?? null;

  if (insertionInfo == null || profile == null || insertionInfo.profileDefaults == null) return null;

  const piggybackSettings = profile && profile.piggybackSettings;
  const defaultPiggybackSettings = getDefaultPiggybackSettings(insertionInfo.profileDefaults);

  const togglePiggyback = () =>
    dispatch(updateActivePiggybackSettings(piggybackSettings ? null : defaultPiggybackSettings));
  const toggleEndVerticalsRunThrough = () =>
    dispatch(
      updateActivePiggybackSettings({
        ...piggybackSettings!,
        runEndVerticalsThrough: !piggybackSettings!.runEndVerticalsThrough,
      }),
    );
  const setPurlinThickness = (purlinThickness: number) =>
    dispatch(updateActivePiggybackSettings({ ...piggybackSettings!, purlinThickness }));

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ display: 'flex', flexDirection: 'row', flex: 1, p: 1, justifyContent: 'space-around' }}>
        <FormControlLabel
          sx={{ m: 1 }}
          control={<Checkbox checked={!!piggybackSettings} onChange={togglePiggyback} />}
          label="Piggyback"
          disabled={!profile}
        />
        <FormControlLabel
          sx={{ m: 1 }}
          control={
            <Checkbox
              checked={(piggybackSettings ?? defaultPiggybackSettings).runEndVerticalsThrough}
              onChange={toggleEndVerticalsRunThrough}
            />
          }
          label="Run End Verticals Through"
          disabled={!piggybackSettings}
        />
      </Box>
      <Box sx={{ display: 'flex', flexDirection: 'row', flex: 1, p: 1, justifyContent: 'space-around' }}>
        <DistanceField
          label="Purlin Thickness"
          value={(piggybackSettings ?? defaultPiggybackSettings).purlinThickness}
          min={0}
          onSubmit={setPurlinThickness}
          disabled={!piggybackSettings}
          sx={{ m: 1, width: '100%' }}
        />
      </Box>
    </Box>
  );
};
